import React from 'react';
import { connect } from 'react-redux';

import HealthManager from '../../../../CharacterSheet/containers/HealthManager';
import { SidebarHeader } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';

class HealthManagePane extends React.PureComponent {
    render() {
        return (
            <div className="ct-health-manage-pane">
                <SidebarHeader>HP Management</SidebarHeader>
                <HealthManager />
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {};
}

export default connect(mapStateToProps)(HealthManagePane);
